import React, { useState } from "react";
import moment from "moment";
import {
    Container,
    Grid,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    Button,
    Modal,
} from "@mui/material";
import ValidateBadgeOB3 from "./ValidateOB30";

// function ValidateBadgeFake({ setShow }) {
//     return (
//         <Box
//             sx={{
//                 backgroundColor: "white",
//                 margin: "auto",
//                 padding: 4,
//                 maxWidth: 400,
//                 borderRadius: 2,
//                 mt: 10,
//                 textAlign: "center",
//             }}
//         >
//             <Typography variant="h6" gutterBottom>
//                 Weryfikacja odznaki
//             </Typography>
//             <Typography sx={{ mb: 3 }}>
//                 Tu możesz dodać logikę weryfikacji.
//             </Typography>
//             <Button variant="contained" onClick={() => setShow(false)}>
//                 Zamknij
//             </Button>
//         </Box>
//     );
// }


function ValidateBadgeFake({ setShow, badge }) {
    const [result, setResult] = useState(null);

    const validateBadge = () => {
        const errors = [];

        if (!badge['@context'] || !Array.isArray(badge['@context'])) {
            errors.push("Brak lub niepoprawny @context");
        }

        if (badge['@type'] !== "VerifiableCredential") {
            errors.push("Niepoprawny typ odznaki (oczekiwano VerifiableCredential)");
        }

        const subject = badge.credentialSubject;
        if (!subject) {
            errors.push("Brak credentialSubject");
        } else {
            const achievement = subject.achievement;
            if (!achievement) {
                errors.push("Brak achievement w credentialSubject");
            } else {
                if (!achievement.name) errors.push("Brak nazwy osiągnięcia");
                if (!achievement.description) errors.push("Brak opisu osiągnięcia");
                if (!achievement.criteria) errors.push("Brak kryteriów osiągnięcia");
                if (!achievement.image?.id) errors.push("Brak obrazu osiągnięcia");
                if (!achievement.id) errors.push("Brak ID osiągnięcia");
            }
        }

        if (!badge.issuanceDate || !moment(badge.issuanceDate, moment.ISO_8601, true).isValid()) {
            errors.push("Brak lub niepoprawna data wystawienia");
        }

        if (!badge.issuer) {
            errors.push("Brak wystawcy (issuer)");
        }

        setResult({
            valid: errors.length === 0,
            errors,
        });
    };


    return (
        <Box
            sx={{
                backgroundColor: "white",
                margin: "auto",
                padding: 4,
                maxWidth: 500,
                borderRadius: 2,
                mt: 10,
                textAlign: "center",
            }}
        >
            <Typography variant="h6" gutterBottom>
                Weryfikacja odznaki
            </Typography>

            {!result ? (
                <Button variant="contained" onClick={validateBadge}>
                    Sprawdź autentyczność
                </Button>
            ) : result.valid ? (
                <>
                    <Typography sx={{ my: 3 }} color="green">
                        ✅ Odznaka wygląda na prawidłową!
                    </Typography>
                </>
            ) : (
                <>
                    <Typography sx={{ my: 2 }} color="error">
                        ❌ Znaleziono błędy:
                    </Typography>
                    <List>
                        {result.errors.map((err, idx) => (
                            <ListItem key={idx}>
                                <ListItemText primary={err} />
                            </ListItem>
                        ))}
                    </List>
                </>
            )}

            <Button sx={{ mt: 3 }} variant="outlined" onClick={() => setShow(false)}>
                Zamknij
            </Button>
        </Box>
    );
}



const defaultBadge = {
    badgeName: "Brak odznaki",
    image: { url: "" },
    description: "",
    issuanceDate: null,
    exam_expiry_date: null,
    user: { firstname: "", lastname: "" },
    badgeType: "",
    qualificationName: "",
    learningEffects: { learningEffects: [] },
};

export default function ExternalBadge() {
    const [badge, setBadge] = useState(defaultBadge);
    const [show, setShow] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type === "application/json") {
            const reader = new FileReader();
            reader.onload = (evt) => {
                try {
                    const json = JSON.parse(evt.target.result);
                    const mappedBadge = {
                        badgeName: json.credentialSubject?.achievement?.name || "Brak nazwy",
                        image: {
                            url:
                                json.credentialSubject?.achievement?.image?.id ||
                                "https://via.placeholder.com/150",
                        },
                        description:
                            json.credentialSubject?.achievement?.description || "",
                        issuanceDate: json.validFrom || null,
                        exam_expiry_date: null,
                        user: {
                            firstname: "Marek",
                            lastname: "Marczak",
                        },
                        badgeType:
                            (json.credentialSubject?.achievement?.achievementType || "").toString() ||
                            "Nieznany",
                        qualificationName:
                            json.credentialSubject?.achievement?.name || "Nieznana kwalifikacja",
                        learningEffects: {
                            learningEffects: json.alignment?.map((item) => ({
                                effectName: item.targetName || "Efekt nauki",
                            })) || [],
                        },
                    };
                    setBadge(mappedBadge);
                } catch (err) {
                    alert("Niepoprawny format JSON w pliku");
                }
            };
            reader.readAsText(file);
        } else {
            alert("Proszę wybrać plik JSON (dla demo)");
        }
    };

    const handleClose = () => setShow(false);

    return (
        <>
            <Container>
                <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
                    <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                        <input
                            type="file"
                            accept=".json,.png"
                            onChange={handleFileChange}
                            style={{ marginBottom: 20 }}
                        />
                        <Typography variant="body2" color="text.secondary">
                            Wczytaj plik JSON lub PNG z zakodowanym mikropoświadczeniem
                        </Typography>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <Typography
                                component="h1"
                                variant="h4"
                                align="center"
                                color="text.primary"
                                sx={{ marginY: "40px" }}
                            >
                                {badge.badgeName}
                            </Typography>
                        </Grid>

                        <Grid container spacing={8}>
                            <Grid item xs={12} md={5} sx={{ textAlign: "center" }}>
                                {badge.image.url ? (
                                    <img
                                        src={badge.image.url}
                                        alt="badge"
                                        style={{ width: "90%", marginTop: "20px" }}
                                    />
                                ) : (
                                    <Typography>Brak obrazka odznaki</Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography
                                    component="h2"
                                    variant="h5"
                                    sx={{
                                        marginBottom: "50px",
                                        textAlign: {
                                            xs: "center",
                                            md: "left",
                                        },
                                    }}
                                >
                                    <span style={{ fontWeight: "bold" }}>{badge.description}</span>
                                </Typography>
                                <Box>
                                    <Typography component="h4" variant="subtitle1">
                                        Data wystawienia:{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                            {badge.issuanceDate
                                                ? moment(badge.issuanceDate).format("LL")
                                                : ""}
                                        </span>
                                    </Typography>
                                    <Typography style={{ color: 'red' }}>{badge.szkolenie}</Typography>
                                    <Typography component="h4" variant="subtitle1">
                                        Data {badge.szkolenie === true ? "ukończenia szkolenia" : "egzaminu"}:{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                            {badge.exam_expiry_date
                                                ? moment(badge.exam_expiry_date).format(
                                                    "LL"
                                                )
                                                : ""}
                                        </span>
                                    </Typography>
                                    <Typography component="h4" variant="subtitle1">
                                        Posiadacz:{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                            {`${badge.user.firstname} ${badge.user.lastname}`}
                                        </span>
                                    </Typography>
                                    <Typography component="h4" variant="subtitle1">
                                        Rodzaj odznaki:{" "}
                                        <span style={{ fontWeight: "bold" }}>{badge.badgeType}</span>
                                    </Typography>
                                    <Typography component="h4" variant="subtitle1">
                                        Kwalifikacja:{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                            {badge.qualificationName}
                                        </span>
                                    </Typography>
                                    <Typography component="h4" variant="subtitle1">
                                        Wystawca:{" "}
                                        <span style={{ fontWeight: "bold" }}>Scrum.org</span>
                                    </Typography>
                                </Box>
                                <Box sx={{ marginTop: "40px" }}>
                                    <Typography component="h4" variant="subtitle1">
                                        EFEKTY UCZENIA SIĘ:
                                        <List>
                                            {badge.learningEffects?.learningEffects.map((item, idx) => (
                                                <ListItem key={idx} sx={{ padding: 0 }}>
                                                    <ListItemText primary={item.effectName} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Typography>
                                </Box>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        mt: 4,
                                        ml: 2,
                                        padding: "15px 32px",
                                        backgroundColor: "#ed6c0217",
                                    }}
                                    onClick={() => setShow(true)}
                                >
                                    Weryfikuj
                                </Button>
                                <Modal
                                    open={show}
                                    onClose={handleClose}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        height: "100vh",
                                        alignItems: "center",
                                    }}
                                >
                                    {/* <ValidateBadgeFake setShow={setShow} badge={badge} /> */}
                                    <ValidateBadgeOB3 setShow={setShow} badge={badge} />
                                </Modal>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}




// import React, { useState } from "react";
// import moment from "moment";
// import {
//     Container,
//     Grid,
//     Typography,
//     Box,
//     List,
//     ListItem,
//     ListItemText,
//     Button,
//     Modal,
// } from "@mui/material";

// function ValidateBadgeFake({ setShow }) {
//     return (
//         <Box
//             sx={{
//                 backgroundColor: "white",
//                 margin: "auto",
//                 padding: 4,
//                 maxWidth: 400,
//                 borderRadius: 2,
//                 mt: 10,
//                 textAlign: "center",
//             }}
//         >
//             <Typography variant="h6" gutterBottom>
//                 Weryfikacja odznaki
//             </Typography>
//             <Typography sx={{ mb: 3 }}>
//                 fdhopsaifhdpsioah fpodisahf poidhsa pfoidhsa pfasd
//             </Typography>
//             <Button variant="contained" onClick={() => setShow(false)}>
//                 Zamknij
//             </Button>
//         </Box>
//     );
// }

// const badgeData = {
//     badgeName: "Professional Scrum Master™ I (PSM I)",
//     image: {
//         url: "https://images.credly.com/images/a2790314-008a-4c3d-9553-f5e84eb359ba/image.png",
//     },
//     description:
//         "Those who earn the globally recognized Professional Scrum Master I (PSM I) certification have demonstrated a fundamental level of Scrum mastery...",
//     issuanceDate: "2021-05-25T16:02:13.000Z",
//     exam_expiry_date: null,
//     user: {
//         firstname: "Marek",
//         lastname: "Marczak",
//     },
//     badgeType: "Achievement",
//     qualificationName: "Professional Scrum Master I Certification",
//     learningEffects: {
//         learningEffects: [
//             { effectName: "Understand Scrum framework" },
//             { effectName: "Apply Scrum in projects" },
//             { effectName: "Lead Scrum teams" },
//         ],
//     },
// };

// export default function ExternalBadge() {
//     const [show, setShow] = useState(false);
//     const badge = badgeData;

//     const handleClose = () => setShow(false);

//     return (
//         <>
//             <Container>
//                 <Grid item xs={12}>
//                     <Grid container spacing={0}>
//                         <Grid item xs={12}>
//                             <Typography
//                                 component="h1"
//                                 variant="h4"
//                                 align="center"
//                                 color="text.primary"
//                                 sx={{ marginY: "40px" }}
//                             >
//                                 {badge.badgeName}
//                             </Typography>
//                         </Grid>

//                         <Grid container spacing={8}>
//                             <Grid item xs={12} md={5} sx={{ textAlign: "center" }}>
//                                 <img
//                                     src={badge.image.url}
//                                     alt="badge"
//                                     style={{ width: "90%", marginTop: "20px" }}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} md={7}>
//                                 <Typography
//                                     component="h2"
//                                     variant="h5"
//                                     sx={{
//                                         marginBottom: "50px",
//                                         textAlign: {
//                                             xs: "center",
//                                             md: "left",
//                                         },
//                                     }}
//                                 >
//                                     <span style={{ fontWeight: "bold" }}>{badge.description}</span>
//                                 </Typography>
//                                 <Box>
//                                     <Typography component="h4" variant="subtitle1">
//                                         Data wystawienia:{" "}
//                                         <span style={{ fontWeight: "bold" }}>
//                                             {moment(badge.issuanceDate).format("LL")}
//                                         </span>
//                                     </Typography>
//                                     <Typography component="h4" variant="subtitle1">
//                                         Data egzaminu:{" "}
//                                         <span style={{ fontWeight: "bold" }}>
//                                             {badge.exam_expiry_date
//                                                 ? moment(badge.exam_expiry_date).format("LL")
//                                                 : ""}
//                                         </span>
//                                     </Typography>
//                                     <Typography component="h4" variant="subtitle1">
//                                         Posiadacz:{" "}
//                                         <span style={{ fontWeight: "bold" }}>
//                                             {`${badge.user.firstname} ${badge.user.lastname}`}
//                                         </span>
//                                     </Typography>
//                                     <Typography component="h4" variant="subtitle1">
//                                         Rodzaj odznaki:{" "}
//                                         <span style={{ fontWeight: "bold" }}>{badge.badgeType}</span>
//                                     </Typography>
//                                     <Typography component="h4" variant="subtitle1">
//                                         Kwalifikacja:{" "}
//                                         <span style={{ fontWeight: "bold" }}>
//                                             {badge.qualificationName}
//                                         </span>
//                                     </Typography>
//                                     <Typography component="h4" variant="subtitle1">
//                                         Wystawca:{" "}
//                                         <span style={{ fontWeight: "bold" }}>Scrum.org</span>
//                                     </Typography>
//                                 </Box>
//                                 <Box sx={{ marginTop: "40px" }}>
//                                     <Typography component="h4" variant="subtitle1">
//                                         EFEKTY UCZENIA SIĘ:
//                                         <List>
//                                             {badge.learningEffects?.learningEffects.map((item, idx) => (
//                                                 <ListItem key={idx} sx={{ padding: 0 }}>
//                                                     <ListItemText primary={item.effectName} />
//                                                 </ListItem>
//                                             ))}
//                                         </List>
//                                     </Typography>
//                                 </Box>
//                                 <Button
//                                     variant="outlined"
//                                     sx={{
//                                         mt: 4,
//                                         ml: 2,
//                                         padding: "15px 32px",
//                                         backgroundColor: "#ed6c0217",
//                                     }}
//                                     onClick={() => setShow(true)}
//                                 >
//                                     Weryfikuj
//                                 </Button>
//                                 <Modal
//                                     open={show}
//                                     onClose={handleClose}
//                                     sx={{
//                                         display: "flex",
//                                         justifyContent: "center",
//                                         height: "100vh",
//                                         alignItems: "center",
//                                     }}
//                                 >
//                                     <ValidateBadgeFake setShow={setShow} />
//                                 </Modal>
//                             </Grid>
//                         </Grid>
//                     </Grid>
//                 </Grid>
//             </Container>
//         </>
//     );
// }
